import { voices } from "@/mocks/chiguaData";
import SectionHeading from "./SectionHeading";

export default function Voices() {
  return (
    <section id="voices" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="评论区前排"
          title="网友锐评"
          desc="蹲在瓜田里的人最有发言权，看看大家都怎么评价这里的反转浓度。"
        />

        <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {voices.map((v) => (
            <figure
              key={v.nickname}
              className="flex flex-col rounded-3xl border border-background-200/70 bg-background-100/50 p-5"
            >
              <div className="flex text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{v.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-user-3-line" aria-hidden="true"></i>
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-950">{v.nickname}</p>
                  <p className="text-xs text-foreground-500">{v.tag}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}